import * as carryForward from '../xhr/carryForward.js';
import * as notifier from './notifier.js';
import * as loader from './loader.js';

/**
 * @param dispatch
 * @param isLoading
 * @param type
 */
function setLoader(dispatch, isLoading, type = 'full') {
    dispatch(loader.setLoader({
        isLoading,
        type
    }));
}

/**
 * 
 * @param {*} isDivision 
 * @param {*} entityID // accountID or userID depending if division or member Carry Forward
 * @returns 
 */
export function getCarryForward(isDivision, entityID) {
    return (dispatch) => {
        setLoader(dispatch, true);
        return carryForward.getCarryForward(isDivision, entityID)
            .then((data) => {
                setLoader(dispatch, false);
                return data;
            })
            .catch((error) => {
                dispatch(notifier.displayError(error));
                setLoader(dispatch, false);
                return false;
            });
    }; 
}

/**
 * 
 * @param {*} isDivision 
 * @param {*} carryForwardID 
 * @returns 
 */
export function removeCarryForward(isDivision, carryForwardID) {
    return (dispatch) => {
        setLoader(dispatch, true);
        return carryForward.removeCarryForward(isDivision, carryForwardID)
            .then(() => {
                setLoader(dispatch, false);
                return true;
            })
            .catch((error) => {
                dispatch(notifier.displayError(error));
                setLoader(dispatch, false);
                return false;
            });
    }; 
}

/**
 *
 * @param {*} isDivision
 * @param {*} amount
 * @param {*} entityID isDivision then divisionID otherwise userID
 * @param type
 * @returns
 */
export function addCarryForward(isDivision, amount = false, entityID = false, type = false) {
    return (dispatch) => {
        setLoader(dispatch, true);
        return carryForward.addCarryForward(isDivision, amount, entityID, type)
            .then(() => {
                setLoader(dispatch, false);
                return true;
            })
            .catch((error) => {
                dispatch(notifier.displayError(error));
                setLoader(dispatch, false);
                return false;
            });
    }; 
}